/* eslint-disable @typescript-eslint/no-unused-vars */
import {v4 as uuid} from 'uuid';

export const getUniqueId = () => {
  // const tuuid = window?.webapis?.appcommon?.getUuid();
  // console.log(tuuid);
  // return window?.webapis?.appcommon?.getUuid() || uuid();
  return uuid();
};
